export default "__VITE_PUBLIC_ASSET__cbad5f49__"